export const SHOW_KEYBOARD = 'SHOW_KEYBOARD';
export const GENERATE_DEVICE_ID = 'GENERATE_DEVICE_ID';
export const STORE_HISTORY = 'STORE_HISTORY';
export const GENERATE_MOBILE_ID = 'GENERATE_MOBILE_ID';
export const STORE_CURRENT_ARTWORK_ID = 'STORE_CURRENT_ARTWORK_ID';
